<template>
  <div class="homework-page">
    <headers :title="title" @toGet="goSearh">
      <template slot="right-sum">
        <img class="search" src="@/assets/images/search.png" alt />
      </template>
    </headers>
    <van-tabs @change="onTabChange" v-model="searchParams.status">
      <van-tab v-for="(item, index) in tabs" :key="index" :title="item.name"></van-tab>
    </van-tabs>
    <div class="search-result" v-if="searchParams.course_id || searchParams.period_id">
      <span v-if="searchParams.course_id">{{course_name}}-作业列表</span>
      <span v-else-if="list.length">{{list[0].course_name+"."+list[0].period_name}}-作业列表</span>
    </div>
    <div class="search-result" v-if="searchParams.keywords">
      <span>{{searchParams.keywords}}的搜索结果</span>
      <i @click="clearSearch" class="close-search"></i>
    </div>
    <empty :empty_type="empty_type" v-show="list.length == 0"></empty>
    <List
      ref="list"
      url="/api/app/homework/list"
      :onGetdata="getList"
      :params="searchParams"
      :onFormatter="onFormatter"
      :showText="list.length>0"
      method="get"
    >
      <div slot="item" class="pack-card">
        <div class="pc-item" v-for="(item,index) in list" :key="index">
          <div class="pc-t">
            <p class="pc-title">{{item.homework_name}}</p>
          </div>
          <div class="pc-info">
            <p>
              <span>{{item.homework_deadline | fomartTime('yyyy.MM.dd hh:mm:ss')}}截止</span>
              <span>
                <font style="color:#EE1F1F;">{{item.score}}</font>分
              </span>
              <span>
                共
                <font class="theme-color">{{item.ques_count}}</font> 道题
              </span>
            </p>
            <p>
              <span>{{item.course_name}}{{item.period_name ? '.'+item.period_name:''}}</span>
            </p>
          </div>
          <!-- 操作 -->
          <div class="footer">
            <div>
              <van-button class="default" v-if="item.homework_status == 2">查看详情</van-button>
              <van-button
                v-else-if="item.report_status==1&&item.homework_deadline>=new Date().getTime()/1000"
                @click="goPage(item,1)"
              >开始答题</van-button>
              <van-button
                v-else-if="item.homework_deadline<new Date().getTime()/1000 && item.report_status == 1"
                @click="goPage(item,3)"
              >预览</van-button>
              <template v-else-if="item.homework_deadline>=new Date().getTime()/1000">
                <van-button @click="goPage(item,2)">查看详情</van-button>
                <van-button @click="goReport(item)">答题报告</van-button>
              </template>
            </div>
            <p v-if="item.report_status == 3">{{item.point}}分</p>
          </div>
          <img
            class="exam-state"
            :src="item.homework_status == 2 ? img['4']: (item.homework_deadline<new Date().getTime()/1000 && item.report_status == 1) ? img['5']:img[item.report_status]"
          />
          <img
            class="exam-nopass"
            src="@/assets/images/homework/is-close.png"
            v-if="item.homework_status == 2"
          />
        </div>
      </div>
    </List>
  </div>
</template>

<script>
import headers from "@/components/Header";
import List from "@/components/List";
import empty from "@/components/Empty";
export default {
  name: "Homework",
  components: {
    headers,
    List,
    empty
  },
  data() {
    return {
      title: {
        name: "我的作业"
      },
      searchParams: {
        keywords: "",
        status: 0,
        init: function() {
          this.status = 0;
          this.course_id = "";
          this.period_id = "";
        }
      },
      tabs: [
        { name: "全部", status: 0 },
        { name: "未完成", status: 1 },
        { name: "待批阅", status: 2 },
        { name: "已完成", status: 3 },
        { name: "已过期", status: 4 }
      ],
      list: [],
      empty_type: {
        name: "暂无作业记录"
      },
      course_name: "",
      img: {
        "2": require("@/assets/images/homework/ready.png"),
        "4": require("@/assets/images/homework/close.png"),
        "3": require("@/assets/images/homework/done.png"),
        "5": require("@/assets/images/homework/over-done.png"),
        "1": require("@/assets/images/homework/not-done.png")
      }
    };
  },
  methods: {
    onFormatter() {},
    goSearh() {
      this.$router.push({
        name: "Search",
        query: {
          name: "HomeWork"
        }
      });
    },
    getList(list) {
      this.list = list;
    },
    onTabChange() {
      // this.searchParams.status = this.tabs[index].status;
      this.$refs.list.reset();
    },
    //  清除搜索条件
    clearSearch() {
      this.$store.commit("OTO_KEY");
      this.searchParams.keywords = "";
      this.$nextTick(() => {
        this.$refs.list.reset();
      });
    },
    searchInit() {
      if (this.$route.query.id) {
        this.searchParams.course_id = this.$route.query.id;
        this.$http
          .get(`/api/app/myStudy/course/${this.$route.query.id}`)
          .then(res => {
            this.course_name = res.course.title;
          });
      } else if (this.$route.query.period_id) {
        this.searchParams.period_id = this.$route.query.period_id;
      }
    },
    goReport(it) {
      this.$router.push({
        name: "HomeworkReport",
        query: {
          id: it.report_id
        }
      });
    },
    goPage(it, type) {
      if (type == 1) {
        // 答题
        this.$router.push({
          name: "DoHomework",
          query: {
            id: it.report_id,
            name: it.homework_name
          }
        });
      } else if (type == 2) {
        // 查看
        this.$router.push({
          name: "DoHomework",
          query: {
            report_id: it.report_id
          }
        });
      } else {
        this.$router.push({
          name: "DoHomework",
          query: {
            preview: 1,
            id: it.report_id,
            name: it.homework_name
          }
        });
      }
    }
  },
  mounted() {
    //   防刷新
    this.searchInit();
  },
  activated() {
    // 从父级进入 初始化
    if (this.$store.state.is_reset) {
      this.$store.commit("IS_RESET_STATE", 0);
      this.searchParams.init();
      this.searchInit();
      this.clearSearch();
      return;
    }
    //  通过搜索携带条件返回
    if (
      this.$store.state.keywords &&
      this.searchParams.keywords != this.$store.state.keywords
    ) {
      this.searchParams.init();
      this.searchParams.keywords = this.$store.state.keywords;
    }
    this.$refs.list.reset();
  }
};
</script>

<style lang="scss" scoped>
.theme-color {
  color: $theme_color;
}
.oto-title {
  font-size: 28px;
  font-family: PingFangSC-Regular;
  font-weight: 400;
  color: rgba(140, 140, 140, 1);
  padding-top: 30px;
  padding-left: 20px;
}
.search-result {
  //   width: 1378px;
  padding: 0 20px;
  min-height: 64px;
  border: 1px solid rgba(65, 105, 255, 0.21);
  border-radius: 4px;
  background: #fbfcff;
  margin: 30px 30px 0 30px;
  display: flex;
  justify-content: space-between;
  align-items: center;
  span {
    font-size: 28px;
    font-family: PingFang SC;
    font-weight: 400;
    color: rgba(38, 38, 38, 1);
    line-height: 44px;
  }
  i {
    width: 30px;
    height: 64px;
    background: url("~@/assets/images/close@2x.png") no-repeat left center;
    background-size: 30px 30px;
  }
}
.homework-page {
  .search {
    width: 38px;
    height: 40px;
    margin-top: 20px;
  }
  .pack-card {
    padding: 10px 20px 0;
    .pc-item {
      background: rgba(255, 255, 255, 1);
      box-shadow: 0px 0px 16px 0px rgba(10, 0, 24, 0.08);
      border-radius: 10px;
      padding: 30px;
      font-family: PingFang SC;
      font-weight: 400;
      margin: 20px 10px 10px;
      position: relative;
      .pc-t {
        display: flex;
        justify-content: space-between;
        p {
          width: 500px;
        }
        span {
          font-size: 26px;
          font-family: PingFang SC;
          font-weight: 400;
          color: rgba(74, 112, 255, 1);
          line-height: 40px;
        }
      }
      .pc-title {
        font-size: 28px;
        color: rgba(38, 38, 38, 1);
        line-height: 40px;
        padding-bottom: 10px;
        width: 600px;
        font {
          font {
            color: #8c8c8c;
          }
        }
      }
      .pc-info {
        p {
          line-height: 46px;
          font-size: 24px;
          color: rgba(140, 140, 140, 1);
          span {
            padding-right: 40px;
          }
        }
      }
      .footer {
        display: flex;
        justify-content: space-between;
        flex-direction: row-reverse;
        padding-top: 20px;
        > p {
          font-size: 40px;
          font-family: PingFang SC;
          font-weight: 600;
          color: rgba(238, 31, 31, 1);
        }
        div {
          button {
            width: 156px;
            height: 56px;
            background: rgba(255, 255, 255, 1);
            border: 1px solid rgba(65, 105, 255, 1);
            border-radius: 28px;
            font-size: 24px;
            text-align: center;
            line-height: 56px;
            color: rgba(65, 105, 255, 1);
            margin-left: 17px;
          }
          .default {
            border-color: #d9d9d9;
            color: #d9d9d9;
          }
        }
      }
      .exam-state {
        position: absolute;
        right: 0;
        top: 0;
        width: 85px;
        height: 83px;
      }
      .exam-nopass {
        position: absolute;
        right: 30px;
        top: 65px;
        width: 88px;
        height: 71px;
      }
    }
  }
}
</style>
